export const skillsData = [
  "JavaScript",
  "React",
  "HTML",
  "TypeScript",
  "React Native",
  "CSS",
  "Python",
  "Vue",
  "Git"
];
